<template>
  <hm-content class="add-keyword-reply-container">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="规则名称" prop="ruleName" v-if="!isSubscribe">
        <el-input
          size="small"
          v-model.trim="ruleForm.ruleName"
          type="text"
          placeholder="请输入规则名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="关键词" prop="ruleName" v-if="!isSubscribe">
        <div
          class="flex item-center"
          v-for="(v, i) in ruleForm.keywordsRuleList"
          :key="i"
        >
          <el-select
            size="small"
            v-model="v.matchType"
            class="mr10"
            style="width: 100px"
          >
            <el-option label="模糊匹配" :value="0"></el-option>
            <el-option label="全匹配" :value="1"></el-option>
          </el-select>
          <el-input
            size="small"
            v-model.trim="v.keyword"
            type="text"
            placeholder="请输入规则名称"
          ></el-input>
          <div class="add-wrapper pointer" v-if="i === 0" @click="addtionTime">
            <span class="hmicon icon-hao"></span>
          </div>
          <div class="minus-wrapper" v-if="i > 0" @click="deleteTime(i)">
            <span class="hmicon icon-jianhao pointer"></span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="回复方式" prop="couponType" v-if="!isSubscribe">
        <el-radio-group v-model="ruleForm.type" size="small">
          <el-radio label="0">回复全部</el-radio>
          <el-radio label="1">随机回复一条</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="回复内容" prop="replyContent">
        <div class="add-wrapper pointer mb20" @click="addReply">
          <span class="hmicon icon-hao"></span>
        </div>
        <div class="table oa-menu mb20" v-if="ruleForm.replyList.length">
          <div class="table-header flex">
            <div class="flex-1 text-center">回复类型</div>
            <div class="flex-1 text-center">内容</div>
            <div class="flex-1 text-center">链接</div>
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <div
              class="flex table-row item-center"
              v-for="(item, index) in ruleForm.replyList"
              :key="index"
            >
              <div class="flex-1">
                {{
                  item.replyType === 0
                    ? "文字"
                    : item.replyType === 1
                    ? "图片"
                    : "图文"
                }}
              </div>
              <div class="flex-1">
                <span v-if="item.contents">{{ item.contents }}</span>
                <div v-if="item.img">
                  <img class="img" :src="item.img" alt="回复图片" />
                </div>
              </div>
              <div class="flex-1">
                <span v-if="item.url">{{ item.url }}</span>
              </div>
              <div class="flex-1">
                <span
                  @click="deleteCurrentReply(index)"
                  class="pointer primary hmicon icon-shanchu"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>

    <el-dialog
      title="添加回复类型"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="回复类型">
          <el-radio-group
            v-model="currentReplyRow.replyType"
            size="small"
            @change="switchReplyType"
          >
            <el-radio :label="0">文字</el-radio>
            <el-radio :label="1">图片</el-radio>
            <el-radio :label="2">图文消息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文本" v-if="currentReplyRow.replyType !== 1">
          <el-input
            max="500"
            type="textarea"
            v-model.trim="currentReplyRow.contents"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" v-if="currentReplyRow.replyType !== 0">
          <div class="flex upload-upload-btn" @click="show = true">
            <div
              v-if="!currentReplyRow.img"
              class="btn flex flex-column flex-center open-file"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>添加图片</span>
            </div>
            <div
              v-if="currentReplyRow.img"
              class="mr10 flex item-end img-wrapper"
              Row
            >
              <img class="logo img" :src="currentReplyRow.img" alt="logo" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input
            type="text"
            size="small"
            placeholder="请输入有限网址链接"
            v-model.trim="currentReplyRow.url"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="saveReply" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="show"
      noCircle
      noSquare
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
  </hm-content>
</template>

<script>
 import myUpload from "vue-image-crop-upload";

export default {
  components: {
     
    myUpload
  },
  data() {
    return {
      show: false,
      dialogVisible: false,
      currentReplyRow: {
        replyType: 0,
        contents: "",
        img: "",
        url: ""
      },
      isSubscribe: false,
      ruleForm: {
        replyList: [],
        keywordsRuleList: [
          {
            matchType: 0,
            keyword: ""
          }
        ],
        ruleName: "",
        type: "0"
      },
      rules: {
        ruleName: {
          max: 60,
          message: "规则名不能大于60个字符",
          trigger: "change"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryReplyDetail();
  },
  mounted() {},
  methods: {
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = {
          wxKeyWordRuleBo: {
            keyWordRuleId: this.$route.query.keyWordRuleId,
            name: this.ruleForm.ruleName,
            status: 1,
            type: this.ruleForm.replyType
          },
          wxKeyWordBo: this.ruleForm.keywordsRuleList,
          wxKeyWordReplyBo: this.ruleForm.replyList
        };
        const { code } = await this.$store.dispatch("editReply", params);
        if (code === 0) {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.$router.back(-1);
        }
      }
    },
    async queryReplyDetail() {
      const { result } = await this.$store.dispatch("queryReplyDetail", {
        keyWordRuleId: this.$route.query.keyWordRuleId
      });
      this.ruleForm.ruleName = result.wxKeyWordRuleVo.name;
      this.ruleForm.type = result.wxKeyWordRuleVo.type;
      this.ruleForm.keywordsRuleList = result.wxKeyWordVo;
      this.ruleForm.replyList = result.wxKeyWordReplyVo;
      this.isSubscribe = Boolean(
        result.wxKeyWordVo.find(v => v.keyword === "subscribe")
      );
    },
    addtionTime() {
      this.ruleForm.keywordsRuleList.push({
        rule: 0,
        keywords: ""
      });
    },
    cropUploadSuccess(jsonData) {
      this.currentReplyRow.img = jsonData.result;
    },
    deleteCurrentReply(i) {
      this.ruleForm.replyList.splice(i, 1);
    },
    addReply() {
      this.dialogVisible = true;
      this.currentReplyRow = {
        replyType: 0,
        contents: "",
        img: "",
        url: ""
      };
    },
    switchReplyType() {
      this.currentReplyRow.contents = "";
      this.currentReplyRow.img = "";
    },
    saveReply() {
      this.ruleForm.replyList.push(this.currentReplyRow);
      this.dialogVisible = false;
    },
    deleteTime(i) {
      this.ruleForm.keywordsRuleList.splice(i, 1);
    }
  }
};
</script>
<style lang="scss">
.add-keyword-reply-container {
  .el-select {
    .el-input {
      width: 100%;
    }
  }
}
.table.oa-menu {
  .el-input {
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .img-wrapper {
    border: 1px dashed #f5f5f5;
    width: 102px;
    position: relative;
    img {
      width: 100%;
    }
    &::after {
      position: absolute;
      content: "更换图片";
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 12px;
      text-align: center;
      height: 30px;
      line-height: 30px;
    }
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.table {
  border: 1px solid #e4e7ed;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
    > div {
      padding: 0 10px;
    }
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
</style>
